import * as React from 'react';
import clsx from 'clsx';
import { SvgIconReact, SvgIconType } from 'common/components/svg-icon';
import { useTranslation } from 'common/i18n/hooks';
import { Trans } from 'common/i18n';
import styles from './index.module.styl';
type NoDataStateProps = {
  onRefresh?: () => void;
  isError?: boolean;
  errorMessage?: string;
};
export const NoDataState = (props: NoDataStateProps) => {
  let copy;
  let icon: SvgIconType;
  let useIcon: boolean;
  const {
    t
  } = useTranslation();
  if (props.isError) {
    useIcon = true;
    icon = "warning";
    copy = <>
        {t("session-replay.load-error")}
        <span onClick={props.onRefresh}>{t("session-replay.refresh")}</span>
      </>;
  } else {
    useIcon = false;
    icon = "replay";
    copy = <Trans i18nKey={"session-replay.no-recent-replays"} t={t} components={{
      docsLink: <a href={"https://docs.mixpanel.com/docs/session-replay"} />
    }} />;
  }
  return <div className={styles.container} data-sentry-component="NoDataState" data-sentry-source-file="index.tsx">
      {useIcon && <div className={clsx(styles.icon, {
      [styles.error]: props.isError
    })}>
          <SvgIconReact icon={icon} />
        </div>}
      <div className={styles.text}>{copy}</div>
    </div>;
};